import { getFirebaseAuth } from "@risalabs_frontend_org/auth-wrapper";
import { updatePassword } from "firebase/auth";
import moment from "moment";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { resetPasswordRateLimiter } from "../../../api/postCall/resetPasswordRateLimiter";
import { AppDispatch } from "../../store/store";
import {
  passwordResetFailure,
  passwordResetStart,
  passwordResetSuccess,
  resetAllStates,
  resetEmailSend,
  resetEmailSendFailure,
} from "../auth-slice";

/**
 * Requests a password-reset email via backend rate-limited flow.
 *
 * @param email - User email to reset password for
 * @returns A thunk that updates reset-email request state
 */
export const resetPasswordViaEmail =
  (email: string) => async (dispatch: AppDispatch) => {
    dispatch(resetAllStates());
    try {
      await resetPasswordRateLimiter(email);
      dispatch(resetEmailSend());
    } catch (error) {
      if (error instanceof Error) {
        dispatch(resetEmailSendFailure(error.message));
      } else {
        dispatch(resetEmailSendFailure("An unknown error occurred."));
      }
    }
  };

/**
 * Updates current user password using the shared auth-wrapper auth instance.
 *
 * @param newPassword - New password value
 * @param uid - Provider document ID to store password update timestamp
 * @returns A thunk that updates password reset state
 */
export const resetPasswordInFirebase =
  (newPassword: string, uid: string) => async (dispatch: AppDispatch) => {
    dispatch(passwordResetStart());
    try {
      const firebaseAuth = getFirebaseAuth();
      const currentUser = firebaseAuth.currentUser;
      if (currentUser) {
        await updatePassword(currentUser, newPassword);
        await FirestoreService.updateDocument("providers", uid, {
          lastPasswordUpdatedOn: moment().toISOString(),
        });
        dispatch(passwordResetSuccess());
      }
    } catch (error) {
      if (error instanceof Error) {
        dispatch(passwordResetFailure(error.message));
      } else {
        dispatch(passwordResetFailure("An unknown error occurred."));
      }
    }
  };
